module.exports = __webpack_public_path__ + "img/logo.eea2ddb3.png";